import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { useLang } from "../../i18n/lang";
import { CONTACT_EMAIL, INSTAGRAM_URL } from "../../lib/api";

export const Footer = () => {
  const { t, to } = useLang();
  const year = new Date().getFullYear();
  const explore = [["stones", "/stones"], ["bespoke", "/bespoke-objects"], ["process", "/process"], ["about", "/about"], ["contact", "/start-a-project"]];
  return (
    <footer className="bg-[#1A1A1A] text-[#FFFFFF] relative overflow-hidden" data-testid="site-footer">
      <div className="px-6 sm:px-10 lg:px-14 pt-24 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Logo size="lg" />
            <p className="mt-8 max-w-sm text-[#D4D4D4] leading-relaxed">{t.footer.desc}</p>
          </div>
          <div className="md:col-span-3">
            <p className="eyebrow text-[#BDBDBD] mb-6">{t.footer.explore}</p>
            <ul className="space-y-3">
              {explore.map(([k, p]) => (
                <li key={k}><Link to={to(p)} className="link-line" data-testid={`footer-${k}`}>{t.nav[k]}</Link></li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="eyebrow text-[#BDBDBD] mb-6">{t.footer.contact}</p>
            <ul className="space-y-3">
              <li><a href={`mailto:${CONTACT_EMAIL}`} className="link-line" data-testid="footer-email">{CONTACT_EMAIL}</a></li>
              {INSTAGRAM_URL && <li><a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" className="link-line" data-testid="footer-instagram">Instagram</a></li>}
            </ul>
            <p className="eyebrow text-[#BDBDBD] mt-10 mb-6">{t.footer.legal}</p>
            <ul className="space-y-3 text-sm">
              <li><Link to={to("/privacy")} className="link-line" data-testid="footer-privacy">{t.footer.privacy}</Link></li>
              <li><Link to={to("/cookies")} className="link-line" data-testid="footer-cookies">{t.footer.cookies}</Link></li>
              <li><Link to={to("/legal")} className="link-line" data-testid="footer-legal">{t.footer.legalInfo}</Link></li>
            </ul>
          </div>
        </div>
        <p aria-hidden="true" className="f-serif font-light leading-[0.8] tracking-[-0.03em] text-[10vw] md:text-[9.6vw] mt-24 -mb-[2vw] text-[#FFFFFF]/[0.08] whitespace-nowrap select-none">
          The Stone Edition
        </p>
        <div className="border-t border-[#FFFFFF]/15 pt-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-[#BDBDBD]">
          <span data-testid="footer-company">{t.footer.company}</span>
          <span>© {year} THE STONE EDITION. {t.footer.rights}</span>
        </div>
      </div>
    </footer>
  );
};
